import { TableMenuActionEnums, TableMenuActionColorEnums } from '@/enums/TableMenuActionEnums';

export interface ITableMenuClickEvent {
    dataSetId: string;
    dataSetCellId?: string;
    action: TableMenuActionEnums;
    color?: TableMenuActionColorEnums;
}

export class TableMenuClickEvent implements ITableMenuClickEvent {
    public dataSetId: string;
    public dataSetCellId?: string;
    public action: TableMenuActionEnums;
    public color?: TableMenuActionColorEnums;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableMenuClickEvent);
    constructor(obj?: any) {
        this.dataSetId = obj && obj.dataSetId || '';
        this.dataSetCellId = obj && obj.dataSetCellId || undefined;
        this.action = obj && obj.action != null ? obj.action : TableMenuActionEnums.UNKNOWN;

        if (obj && obj.color != null) {
            this.color = obj.color;
        }
    }
}
